









































import Vue from "vue";
import Component from "vue-class-component";
import { ReportDetail_report_attachments } from "@/models/queries/types/ReportDetail";
import { Fragment } from "vue-fragment";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import { UserService } from "@/services/UserService";
import { ReportOverview } from "@/models/queries/ReportOverviewQuery";
import SheetCardsFilter from "./sheet-cards-filter.component.vue";
import { DataProgress, DataValidation } from "@/models/graphql-global-types";
import { Watch } from "vue-property-decorator";
@Component({
  props: {
    report: Object,
    selectedSheet: Object,
    selectSheet: Function
  },
  components: {
    Fragment,
    ClipLoader,
    SheetCardsFilter
  }
})
export default class SheetCards extends Vue {
  private isUserAdmin = UserService.isUserAdmin;
  private isUserTester = UserService.isUserTester;
  private isUserViewer = UserService.isUserViewer;
  public filteredSheets: any[] = [];
  private selectedProgress: DataProgress[] = [];
  private selectedDataValidations: DataValidation[] = [];
  private selectedScrewDiameter: string | null = null;

  public mounted() {
    this.filteredSheets = this.$props.report.sheets;
  }

  public isUserOwnerOfReport(report: ReportOverview) {
    return UserService.isUserOwnerOfReport(report);
  }

  public setScrewDiameter(screwDiameter: string) {
    this.selectedScrewDiameter = screwDiameter;
    this.applyFilter();
  }

  private setProgress(clickedProgress: DataProgress) {
    const index = this.selectedProgress.indexOf(clickedProgress);
    if (index >= 0) {
      this.selectedProgress.splice(index, 1);
    } else {
      this.selectedProgress.push(clickedProgress);
    }
    this.applyFilter();
  }

  private setDataValidation(clickedValidation: DataValidation) {
    const index = this.selectedDataValidations.indexOf(clickedValidation);
    if (index >= 0) {
      this.selectedDataValidations.splice(index, 1);
    } else {
      this.selectedDataValidations.push(clickedValidation);
    }
    this.applyFilter();
  }

  private applyFilter() {
    let filtered = this.$props.report.sheets;
    if (this.selectedProgress.length > 0) {
      filtered = filtered.filter(s => this.selectedProgress.includes(s.dataProgress));
    }
    if (this.selectedDataValidations.length > 0) {
      filtered = filtered.filter(s => {
        if (this.selectedDataValidations.includes(DataValidation.TESTED_OK)) {
          return (
            this.selectedDataValidations.includes(s.dataValidation) ||
            s.dataValidation === DataValidation.NOT_TESTED ||
            !s.dataValidation
          );
        }
        return this.selectedDataValidations.includes(s.dataValidation);
      });
    }
    if (this.selectedScrewDiameter) {
      filtered = filtered.filter(s => {
        return s.product.screwDiameter === this.selectedScrewDiameter;
      });
    }

    this.filteredSheets = filtered;
  }

  @Watch("report")
  public onReportChanged(newReport: any) {
    this.applyFilter();
  }
}
